import clsx from 'clsx';
import React from 'react';

import IconProTagArticle from '@components/Images/Rebranding/IconProTagArticle';
import LazyImgixImage from '@components/LazyImgixImage';
import { getArticleImgSrc } from '@utils/images';

import ArticleDetails from '../ArticleDetails';
import Header from '../Header';
import PictureCaption from '../PictureCaption';
import { ThemeViewsProps } from '../interfaces';
import styles from '../styles.module.scss';
import Content from './Content';

const Feature = ({
  article: {
    addendum,
    advertisement,
    authors,
    commentsCount,
    commenters,
    freeBlurb,
    fullText,
    highlight,
    id,
    isPro,
    pickups,
    picture,
    pictureCaption,
    pictureLink,
    publishedAt,
    scriptList,
    subTitle,
    takeaway,
    title,
  },
  canShareArticle,
  canViewFullArticle,
  canViewComments,
  clipperProps,
  endOfArticleDeepResearchPrompts,
  env,
  isSEOBotAndArticleIsNotFree,
  midArticleUnitType,
  mostPopularArticles,
  newsletterId,
  relatedArticles,
  relatedEvent,
  suggestedAiPrompts,
}: ThemeViewsProps) => {
  const Picture = (
    <LazyImgixImage
      alt={title}
      className="article-hero-image h-auto w-full"
      src={getArticleImgSrc(id, picture, env)}
      visibleByDefault
      wrapperClassName="w-full h-full"
    />
  );

  return (
    <>
      <figure className="relative m-auto h-[calc(100vw*(9/16))]" aria-labelledby="caption-text">
        {isPro && <IconProTagArticle className="absolute right-0 top-0 w-[65px] sm:w-[119px]" />}
        {pictureLink ? <a href={pictureLink}>{Picture}</a> : Picture}
      </figure>
      <div className="px-16 sm:px-28">
        <div
          className={clsx('relative m-auto lg:max-w-[1060px] xl:max-w-container-lg', {
            'mb-80 sm:mb-112': !!midArticleUnitType && canViewFullArticle,
          })}
        >
          <div
            className={clsx(
              styles.headerContainer,
              'absolute -left-36 -top-[92px] z-0 hidden h-[320px] bg-white lg:block lg:w-[844px] xl:w-[1012px]'
            )}
          />
          <div className="relative z-[1] flex flex-col-reverse lg:flex-row lg:gap-72 xl:gap-112">
            <div className="flex-1 pt-28 sm:pt-48 lg:-mt-[92px] lg:pt-24">
              <Header highlight={highlight} title={title} subTitle={subTitle} />
              <div className="mb-40 mt-32 sm:mb-48 sm:mt-48 md:mb-64">
                <ArticleDetails
                  authors={authors}
                  commentsCount={commentsCount}
                  commenters={commenters}
                  publishedAt={publishedAt}
                  canShareArticle={canShareArticle}
                  articleId={id}
                />
              </div>
            </div>
            <PictureCaption pictureCaption={pictureCaption} />
          </div>
          <Content
            addendum={addendum}
            advertisement={advertisement}
            authors={authors}
            bodyClassName={styles.isFeature}
            canViewFullArticle={canViewFullArticle}
            canViewComments={canViewComments}
            clipperProps={clipperProps}
            commentsCount={commentsCount}
            endOfArticleDeepResearchPrompts={endOfArticleDeepResearchPrompts}
            env={env}
            freeBlurb={freeBlurb}
            fullText={fullText}
            highlight={highlight}
            id={id}
            isSEOBotAndArticleIsNotFree={isSEOBotAndArticleIsNotFree}
            midArticleUnitType={midArticleUnitType}
            mostPopularArticles={mostPopularArticles}
            newsletterId={newsletterId}
            pickups={pickups}
            relatedArticles={relatedArticles}
            relatedEvent={relatedEvent}
            scriptList={scriptList}
            suggestedAiPrompts={suggestedAiPrompts}
            takeaway={takeaway}
          />
        </div>
      </div>
    </>
  );
};

export default Feature;
